import { Component, Input, OnInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import {
  FormBuilder,
  Validators,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { AuthenticationService } from '../../../services/auth/authentication.service';
import {
  ActivatedRoute,
  Router,
  NavigationStart,
  RouterLink,
  RouterLinkActive,
} from '@angular/router';
import { environment } from '../../../../environments/environment';
import { CommonService } from 'src/app/services/api/common.service';
import { NgxUiLoaderService } from 'ngx-ui-loader'; // Import NgxUiLoaderService
import { MixpanelService } from 'src/app/mixpanel.service';
// declare var myExternalJs: any;
import { SharedService } from 'src/app/services/api/message.service';
import { CommonAnnouncementComponent } from 'src/app/pages/common/common-announcement/common-announcement.component';
import { Subscription } from 'rxjs';
import { DirectivesModule } from 'src/app/directives.module';
import { ToastrService } from 'ngx-toastr';
import { co, el } from '@fullcalendar/core/internal-common';
declare var Canny: any; // Add this at the top of your TS file
import { CommonModule, NgClass, NgIf, NgFor } from '@angular/common';
import { PermissionService } from 'src/app/services/auth/permissions.service';

// import { Role } from 'src/app/models/permissions.model';
// import { MOCK_USERS } from '../../../services/auth/mock-user';
// import { PermissionService } from '../../../services/auth/permissions.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],

  standalone: true,
  imports: [
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule,
    CommonAnnouncementComponent,
    RouterLink,
    RouterLinkActive,
    NgIf,
    NgFor,
    CommonModule
  ],
})
export class LoginComponent implements OnInit {
  otpTimer: number = 0;
  otpTimerInterval: any = null;
  canResendOtp: boolean = false;
  otpSendCount: number = 0;
  maxOtpSends: number = 2; // Maximum allowed OTP sends (initial + resends)
  @Input() announcementData = ''; // Your dynamic message
  @ViewChildren('digit0, digit1, digit2, digit3, digit4, digit5') digitInputs!: QueryList<ElementRef>;

  sub!: Subscription;
  mandatoryMessage: boolean = false;
  validationMessage: boolean = false;
  is_job_only_user: any;
  access_token: any;
  username: any;
  password: any;
  public loginForm = this.loginFormFB.group({
    client_id: [environment.client_id],
    client_secret: [environment.client_secret],
    grant_type: ['password'],
    username: ['', Validators.required],
    password: ['', Validators.required],
    rememberMe: [false]
  });
  public mfaForm = this.loginFormFB.group({
    remember_until: true,
  });

  token_type: any;
  refresh_token: any;
  booking_school_switch_angular: any;
  from: any;
  redirectToPage: any;
  window: any;
  jobSchoolUrl: boolean = false;
  postCallOut: any;
  terms_accepted: any;
  jobId: any;
  environmentURL: any;
  CusMixData: any;
  error_log: any;
  redirect_user: any;
  booking_id: any;
  isJobLoginDesign: boolean = false;
  isSchoolLoginDesign: boolean = false;
  userEmail: any;
  expiryTime: number = 0;
  isSmsOtpSent: boolean = false;
  profileBookings: any;
  verifyBtnDisable: boolean = false;
  userData: any;
  from_page_cookie: any;

  constructor(
    private router: Router,
    private loginFormFB: FormBuilder,
    private authService: AuthenticationService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private ngxService: NgxUiLoaderService,
    private mixpanelService: MixpanelService,
    private sharedService: SharedService,
    private toastr: ToastrService,
    private permissionService: PermissionService
  ) { }

  ngOnInit(): void {
    // If ?otp=enter_otp is in the URL, show OTP input
    this.route.queryParams.subscribe((params) => {
      if (params['otp'] === 'enter_otp') {
        this.showOtpInput = true;
      }
    });
    this.environmentURL = environment.apiUrl;
    this.access_token =
      document.cookie
        .match('(^|;)\\s*' + 'access_token' + '\\s*=\\s*([^;]+)')
        ?.pop() || '';
    this.refresh_token =
      document.cookie
        .match('(^|;)\\s*' + 'refresh_token' + '\\s*=\\s*([^;]+)')
        ?.pop() || '';
    this.redirect_user =
      document.cookie
        .match('(^|;)\\s*' + 'redirect_user' + '\\s*=\\s*([^;]+)')
        ?.pop() || '';
    this.booking_id =
      document.cookie
        .match('(^|;)\\s*' + 'booking_id' + '\\s*=\\s*([^;]+)')
        ?.pop() || '';
    this.route.queryParams.subscribe((params) => {
      this.jobId = params['jobId'];
    }); this.route.queryParams.subscribe((params) => {
      this.profileBookings = params['from'];
    });
    this.loginForm.get('username')?.valueChanges.subscribe(value => {
      if (value) this.mandatoryMessage = false;
    });
    this.loginForm.get('password')?.valueChanges.subscribe(value => {
      if (value) this.mandatoryMessage = false;
    });

    // Get cookie in ngOnInit
    function getCookie(name: string): string | null {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? decodeURIComponent(match[2]) : null;
    }
    const rememberedUsername = getCookie('rememberedUsername');
    if (rememberedUsername) {
      this.loginForm.patchValue({ username: rememberedUsername, rememberMe: true });
    }
    // document.cookie = "sessionid=; path=/; domain=." + environment.cookDomain + "; expires=" + new Date(0).toUTCString();
    // document.cookie = "csrftoken=; path=/; domain=." + environment.cookDomain + "; expires=" + new Date(0).toUTCString();
    const hostname = window.location.hostname;
    if (hostname === 'jobs.classcover.com.au' || hostname === 'jobs-test.classcover.com.au') {
      this.isSchoolLoginDesign = true;
    } else if (hostname === 'booking.classcover.com.au' || hostname === 'booking-test.classcover.com.au' || hostname === 'localhost' || hostname === 'qld-dev.classcover.com.au') {
      this.isSchoolLoginDesign = true;
    } else {
      this.isSchoolLoginDesign = true;
    }
    if (window.location.hostname == 'jobs.classcover.com.au') {
      this.jobSchoolUrl = true;
    }
    if (window.location.hostname == 'jobs-test.classcover.com.au') {
      this.jobSchoolUrl = true;
    }

    if (this.access_token != '') {
      this.ngxService.start();
      let redirect_user: any = '';
      if (this.redirect_user != '' && this.redirect_user != undefined) {
        // console.log('redirect_user', this.redirect_user);
        redirect_user = {
          user_id: this.redirect_user,
          booking_id: this.booking_id,
        };
      }
      // document.cookie = "access_token=" + this.access_token + ";domain=." + environment.cookiesDomain + ";path=/";
      // document.cookie = "refresh_token=" + this.refresh_token + ";domain=." + environment.cookiesDomain + ";path=/";
      this.commonService.getUserData('').subscribe({
        next: (res) => {
          if (res.status) {
            var userRole = res.data.properties.user_type.replace(
              /[^a-zA-Z ]/g,
              ''
            );
            if (
              userRole != 'Group' &&
              userRole != 'GroupCoordinator' &&
              userRole != 'Teacher' &&
              userRole != 'Tracer'
            ) {
              // console.log('res from me call', res);
              if (
                window.location.hostname == 'booking.classcover.com.au' &&
                res.data.properties.job_only_school == true
              ) {
                window.location.replace('https://jobs.classcover.com.au');
              }
              if (
                window.location.hostname == 'booking-test.classcover.com.au' &&
                res.data.properties.job_only_school == true
              ) {
                window.location.replace('https://jobs-test.classcover.com.au');
              }
              this.is_job_only_user = res.data.properties.job_only_school;
              localStorage.setItem(
                'schoolId',
                res.data.mixpanel_data.school_id
              );
              localStorage.setItem(
                'current_plan',
                res.data.mixpanel_data.current_plan
              );
              localStorage.setItem('userData', JSON.stringify(res.data));
              let switchUserId = localStorage.getItem('switch_user_id');
              if (switchUserId) {
                window.dispatchEvent(new Event('user-switched'));
              }
              localStorage.setItem('userRole', userRole);
              document.cookie =
                'userRole=' +
                userRole +
                ';domain=.' +
                environment.cookiesDomain +
                ';path=/';
              localStorage.setItem(
                'schoolAdId',
                res.data.properties.additional_user_id
              );
              localStorage.setItem(
                'schoolLogo',
                res.data.mixpanel_data.school_avatar
              );
              localStorage.setItem(
                'bookingSchool',
                res.data.properties.is_booking_school
              );
              localStorage.setItem(
                'booking_school',
                res.data.properties.booking_school
              );
              this.mixpanelService.init(
                res.data.mixpanel_data.user_id.toString(),
                res.data.mixpanel_data.mixpanel_app_id
              );
              this.redirectToPage = res.data.properties.is_land_on_preconfirmed;
              this.terms_accepted = res.data.properties.terms_accepted;
              this.CusMixData = res.data.mixpanel_data;
              this.toPageTredirection(
                res.data.properties.user_type,
                res.data.properties.is_onboarding
              );
            } else {
              // Set bookings_on_off cookie based on using_cc_to_B
              const bookingsValue = res.data.properties.using_cc_to_B ? '1' : '0';

              localStorage.setItem('userData', JSON.stringify(res.data));
              localStorage.setItem('userRole', userRole);
              // Set bookings_on_off cookie based on using_cc_to_B
              if (typeof res.data.properties.using_cc_to_B !== 'undefined') {
                const bookingsValue = res.data.properties.using_cc_to_B ? '1' : '0';
                document.cookie = 'bookings_on_off=' + bookingsValue + '; path=/;';
                localStorage.setItem('bookings_on_off', bookingsValue);
              }
              this.is_job_only_user = res.data.properties.job_only_teacher;

              document.cookie =
                'userRole=' +
                userRole +
                ';domain=.' +
                environment.cookiesDomain +
                ';path=/';

              this.toPageTredirection(res.data.properties.user_type, '');
            }
          } else {
            if (res.user_type == 'Group') {
              this.toastr.error(res.message);
              this.authService.loggedOutCookieClear();
              setTimeout(() => {
                if (window.location.hostname == 'booking.classcover.com.au') {
                  window.location.replace('https://app.classcover.com.au/');
                } else if (
                  window.location.hostname == 'booking-test.classcover.com.au'
                ) {
                  window.location.replace('https://phoenix.classcover.com.au/');
                } else if (
                  window.location.hostname == 'qld-beta.classcover.com.au'
                ) {
                  window.location.replace('https://gamma.classcover.com.au/');
                } else {
                  window.location.replace('https://phoenix.classcover.com.au/');
                }
                this.ngxService.stop();
              }, 2000);
            } else if (res.user_type == 'Teacher') {
              this.toastr.error(res.message);
              this.authService.loggedOutCookieClear();
              setTimeout(() => {
                if (window.location.hostname == 'booking.classcover.com.au') {
                  window.location.replace('https://app.classcover.com.au/');
                } else if (
                  window.location.hostname == 'booking-test.classcover.com.au'
                ) {
                  window.location.replace('https://phoenix.classcover.com.au/');
                } else if (
                  window.location.hostname == 'qld-beta.classcover.com.au'
                ) {
                  window.location.replace('https://gamma.classcover.com.au/');
                } else {
                  window.location.replace('https://phoenix.classcover.com.au/');
                }
                this.ngxService.stop();
              }, 2000);
            } else {
              this.toastr.error(res.message);
              this.authService.loggedOutCookieClear();
              setTimeout(() => {
                if (window.location.hostname == 'booking.classcover.com.au') {
                  window.location.replace('https://app.classcover.com.au/');
                } else if (
                  window.location.hostname == 'booking-test.classcover.com.au'
                ) {
                  window.location.replace('https://phoenix.classcover.com.au/');
                } else if (
                  window.location.hostname == 'qld-beta.classcover.com.au'
                ) {
                  window.location.replace('https://gamma.classcover.com.au/');
                } else {
                  window.location.replace('https://phoenix.classcover.com.au/');
                }
                this.ngxService.stop();
              }, 2000);
            }
          }
        },
        error: (err) => {
          console.error('Error fetching user data:', err);
          this.ngxService.stop();
          this.sharedService.announcement.next(
            'An error occurred while fetching user data.'
          );
        },
      });
    }
  }

  ngAfterContentInit() {
    if (window.location.hostname == 'https://jobs.classcover.com.au') {
      this.jobSchoolUrl = true;
    }
    if (window.location.hostname == 'https://jobs-test.classcover.com.au') {
      this.jobSchoolUrl = true;
    }
    this.sub = this.sharedService.announcement.subscribe((data) => {
      this.announcementData = data;
    });
  }

  getFormControlValue() {
    return this.loginForm.value;
  }

  logIn() {

    this.mandatoryMessage = false;
    this.validationMessage = false;
    const username = this.loginForm.value.username ?? '';
    const password = this.loginForm.value.password ?? '';
    const rememberMe = this.loginForm.value.rememberMe ?? false;
    if (rememberMe) {
      document.cookie = `rememberedUsername=${encodeURIComponent(username)}; path=/; max-age=31536000`; // 1 year
    } else {
      document.cookie = `rememberedUsername=; path=/; expires=${new Date(0).toUTCString()}`;
    }
    // Check for 'from' param in URL
    let fromLearnworld = 0;
    this.route.queryParams.subscribe(params => {
      if (params['from'] && params['from'] === 'classcoverlearn') {
        fromLearnworld = 1;
      }
    });
    if (!username || !password) {
      this.validationMessage = false;
      this.mandatoryMessage = true;
      this.sharedService.announcement.next(
        'Please Enter User Name and Password'
      );
    } else {
      // Clone loginForm value and add from_learnworld
      const loginPayload = { ...this.loginForm.value, from_learnworld: fromLearnworld };
      // Reset OTP send count on new login attempt
      this.otpSendCount = 1;
      // Call send-mfa API
      this.commonService.mfaVerifyAPI(loginPayload).subscribe({
        next: (response) => {
          console.log('MFA API response:', response);
          if (response.status === false) {
            this.ngxService.stop();
            this.sharedService.announcement.next(
              'An error occurred while fetching user data.'
            );
            this.mandatoryMessage = false;
            this.validationMessage = true;
            this.error_log = response.error_log;
            this.sharedService.announcement.next(response.error_log);
            this.ngxService.stop();
            return;
          } else if ('email_verified' in response && !response.email_verified) {
            this.showOtpInput = false;
            this.emailVerified = true;
            this.mfaUserId = response.user_id || '';
            this.userEmail = response.email || this.loginForm.value.username || '';
            this.expiryTime = response.expires_in || 10;
            this.startOtpTimer(response.cooldown || 60);
            this.canResendOtp = false;
          } else if (response.mfa_required) {
            this.showOtpInput = true;
            this.emailVerified = false;
            this.mfaUserId = response.user_id || '';
            this.userEmail = response.email || '';
            this.expiryTime = response.expires_in || '';
            this.startOtpTimer(response.cooldown || 60);
            this.canResendOtp = false;

          } else if (!response.mfa_required) {
            if (this.otpTimerInterval) {
              clearInterval(this.otpTimerInterval);
            }
            this.authService.loginOauth(loginPayload).subscribe({
              next: (res) => {
                // console.log('Login successful:', res);
                if (res?.response?.url) {
                  window.location.href = res?.response?.url;
                  return;
                }
                this.commonService.getUserData('').subscribe((res) => {
                  if (res.status) {

                    // ...existing code...
                    var userRole = res.data.properties.user_type.replace(
                      /[^a-zA-Z ]/g,
                      ''
                    );
                    // ...existing code...
                    if (
                      userRole != 'Group' &&
                      userRole != 'GroupCoordinator' &&
                      userRole != 'Teacher' &&
                      userRole != 'Tracer'
                    ) {
                      // console.log('res from me call', res);
                      if (
                        window.location.hostname == 'booking.classcover.com.au' &&
                        res.data.properties.job_only_school == true
                      ) {
                        window.location.replace('https://jobs.classcover.com.au');
                      }
                      if (
                        window.location.hostname == 'booking-test.classcover.com.au' &&
                        res.data.properties.job_only_school == true
                      ) {
                        window.location.replace('https://jobs-test.classcover.com.au');
                      }
                      this.is_job_only_user = res.data.properties.job_only_school;
                      localStorage.setItem(
                        'schoolId',
                        res.data.mixpanel_data.school_id
                      );
                      localStorage.setItem(
                        'current_plan',
                        res.data.mixpanel_data.current_plan
                      );
                      localStorage.setItem('userData', JSON.stringify(res.data));
                      localStorage.setItem('userRole', userRole);
                      document.cookie =
                        'userRole=' +
                        userRole +
                        ';domain=.' +
                        environment.cookiesDomain +
                        ';path=/';
                      localStorage.setItem(
                        'schoolAdId',
                        res.data.properties.additional_user_id
                      );
                      localStorage.setItem(
                        'schoolLogo',
                        res.data.mixpanel_data.school_avatar
                      );
                      localStorage.setItem(
                        'bookingSchool',
                        res.data.properties.is_booking_school
                      );
                      localStorage.setItem(
                        'booking_school',
                        res.data.properties.booking_school
                      );
                      this.mixpanelService.init(
                        res.data.mixpanel_data.user_id.toString(),
                        res.data.mixpanel_data.mixpanel_app_id
                      );
                      this.redirectToPage =
                        res.data.properties.is_land_on_preconfirmed;
                      this.terms_accepted = res.data.properties.terms_accepted;
                      this.CusMixData = res.data.mixpanel_data;
                      this.toPageTredirection(
                        res.data.properties.user_type,
                        res.data.properties.is_onboarding,
                        res.data.mixpanel_data.email,
                        res.data.mixpanel_data.name,
                        res.data.mixpanel_data.user_id,
                      );
                    } else {
                      localStorage.setItem('userData', JSON.stringify(res.data));
                      localStorage.setItem('userRole', userRole);
                      this.is_job_only_user = res.data.properties.job_only_teacher;
                      // Set bookings_on_off cookie based on using_cc_to_B
                      if (typeof res.data.properties.using_cc_to_B !== 'undefined') {
                        const bookingsValue = res.data.properties.using_cc_to_B ? '1' : '0';
                        document.cookie = 'bookings_on_off=' + bookingsValue + '; path=/;';
                        localStorage.setItem('bookings_on_off', bookingsValue);
                      }
                      document.cookie =
                        'userRole=' +
                        userRole +
                        ';domain=.' +
                        environment.cookiesDomain +
                        ';path=/';
                      this.toPageTredirection(res.data.properties.user_type, '');
                    }
                  } else if (res.user_type == 'Group') {
                    this.toastr.error(res.message);
                    this.authService.loggedOutCookieClear();
                    setTimeout(() => {
                      if (window.location.hostname == 'booking.classcover.com.au') {
                        window.location.replace('https://app.classcover.com.au/');
                      } else if (
                        window.location.hostname == 'booking-test.classcover.com.au'
                      ) {
                        window.location.replace('https://phoenix.classcover.com.au/');
                      } else if (
                        window.location.hostname == 'qld-beta.classcover.com.au'
                      ) {
                        window.location.replace('https://gamma.classcover.com.au/');
                      } else {
                        window.location.replace('https://phoenix.classcover.com.au/');
                      }
                      this.ngxService.stop();
                    }, 2000);
                  } else if (res.user_type == 'Teacher') {
                    localStorage.setItem('userData', JSON.stringify(res.data));
                    localStorage.setItem('userRole', userRole);
                    this.is_job_only_user = res.data.properties.job_only_teacher;
                    // Set bookings_on_off cookie based on using_cc_to_B
                    if (typeof res.data.properties.using_cc_to_B !== 'undefined') {
                      const bookingsValue = res.data.properties.using_cc_to_B ? '1' : '0';
                      document.cookie = 'bookings_on_off=' + bookingsValue + '; path=/;';
                      localStorage.setItem('bookings_on_off', bookingsValue);
                    }
                    document.cookie =
                      'userRole=' +
                      userRole +
                      ';domain=.' +
                      environment.cookiesDomain +
                      ';path=/';
                    this.toPageTredirection(res.data.properties.user_type, '');
                  } else {
                    this.toastr.error(res.message);
                    this.authService.loggedOutCookieClear();
                    setTimeout(() => {
                      if (window.location.hostname == 'booking.classcover.com.au') {
                        window.location.replace('https://app.classcover.com.au/');
                      } else if (
                        window.location.hostname == 'booking-test.classcover.com.au'
                      ) {
                        window.location.replace('https://phoenix.classcover.com.au/');
                      } else if (
                        window.location.hostname == 'qld-beta.classcover.com.au'
                      ) {
                        window.location.replace('https://gamma.classcover.com.au/');
                      } else {
                        window.location.replace('https://phoenix.classcover.com.au/');
                      }
                      this.ngxService.stop();
                    }, 2000);
                  }
                });
              },
              error: (err) => {
                this.ngxService.stop();
                this.sharedService.announcement.next(
                  'An error occurred while fetching user data.'
                );
                this.mandatoryMessage = false;
                this.validationMessage = true;
                this.error_log = err.error.error_log;
                this.sharedService.announcement.next(err.error.error_log);
                this.ngxService.stop();
              },
            });
          }
        },
        error: (error) => {
          console.error('MFA API error:', error);
        },
      });
    }
  }
  showOtpInput: boolean = false;
  emailVerified: boolean = false;
  otp: string[] = ['', '', '', '', '', ''];
  mfaUserId: string = '';
  otpError: string = '';
  // MFA state


  onOtpChange(index: number, event: any) {
    let value = event.target.value;
    // Only allow one digit per box
    if (value.length > 1) {
      value = value.slice(-1);
      event.target.value = value;
    }
    if (/^[0-9]?$/.test(value)) {
      this.otp[index] = value;
      // Only move focus if a digit was entered and only update the current box
      if (value && index < 5) {
        const nextInput = document.getElementById('otp-input-' + (index + 1));
        if (nextInput) {
          nextInput.focus();
        }
      }
    }
  }
  onDigitInput(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if (value.length === 1 && index < 5) {
      const nextInput = this.digitInputs.get(index + 1);
      if (nextInput) {
        (nextInput.nativeElement as HTMLInputElement).focus();
      }
    } else if (event.key === 'Backspace' && index > 0 && !value) {
      const prevInput = this.digitInputs.get(index - 1);
      if (prevInput) {
        (prevInput.nativeElement as HTMLInputElement).focus();
      }
    }
    this.verifyBtnDisable = (this.otp.every(digit => digit.length === 1));
  }
  submitOtp(type: 'mfa' | 'email') {
    console.log('Submitting OTP:', this.otp.join(''), 'for type:', type);
    this.otpError = '';
    const otpValue = this.otp.join('');
    if (otpValue.length !== 6) {
      this.otpError = 'Please enter the 6-digit OTP.';
      return;
    }
    const payload = { user_id: this.mfaUserId, otp: otpValue, remember_until: this.mfaForm.value.remember_until };
    if (type === 'mfa') {
      this.authService.login(payload).subscribe({
        next: (res) => {
          if (!res.status) {
            this.otpError = res.message || 'Invalid code. Please check and try again.';
            this.ngxService.stop();
            return
          }
          // console.log('Login successful:', res);
          this.commonService.getUserData('').subscribe((res) => {
            if (res.status) {
              if (
                window.location.hostname == 'booking.classcover.com.au' &&
                res.data.properties.job_only_school == true
              ) {
                window.location.replace('https://jobs.classcover.com.au');
              }
              // ...existing code...
              var userRole = res.data.properties.user_type.replace(
                /[^a-zA-Z ]/g,
                ''
              );
              // ...existing code...
              if (
                userRole != 'Group' &&
                userRole != 'GroupCoordinator' &&
                userRole != 'Teacher' &&
                userRole != 'Tracer'
              ) {
                this.is_job_only_user = res.data.properties.job_only_school;
                localStorage.setItem(
                  'schoolId',
                  res.data.mixpanel_data.school_id
                );
                localStorage.setItem(
                  'current_plan',
                  res.data.mixpanel_data.current_plan
                );
                localStorage.setItem('userData', JSON.stringify(res.data));
                localStorage.setItem('userRole', userRole);
                document.cookie =
                  'userRole=' +
                  userRole +
                  ';domain=.' +
                  environment.cookiesDomain +
                  ';path=/';
                localStorage.setItem(
                  'schoolAdId',
                  res.data.properties.additional_user_id
                );
                localStorage.setItem(
                  'schoolLogo',
                  res.data.mixpanel_data.school_avatar
                );
                localStorage.setItem(
                  'bookingSchool',
                  res.data.properties.is_booking_school
                );
                localStorage.setItem(
                  'booking_school',
                  res.data.properties.booking_school
                );
                this.mixpanelService.init(
                  res.data.mixpanel_data.user_id.toString(),
                  res.data.mixpanel_data.mixpanel_app_id
                );
                this.redirectToPage =
                  res.data.properties.is_land_on_preconfirmed;
                this.terms_accepted = res.data.properties.terms_accepted;
                this.CusMixData = res.data.mixpanel_data;
                this.toPageTredirection(
                  res.data.properties.user_type,
                  res.data.properties.is_onboarding,
                  res.data.mixpanel_data.email,
                  res.data.mixpanel_data.name,
                  res.data.mixpanel_data.user_id,
                );
              } else {
                localStorage.setItem('userData', JSON.stringify(res.data));
                localStorage.setItem('userRole', userRole);
                this.is_job_only_user = res.data.properties.job_only_teacher;
                // Set bookings_on_off cookie based on using_cc_to_B
                if (typeof res.data.properties.using_cc_to_B !== 'undefined') {
                  const bookingsValue = res.data.properties.using_cc_to_B ? '1' : '0';
                  document.cookie = 'bookings_on_off=' + bookingsValue + '; path=/;';
                  localStorage.setItem('bookings_on_off', bookingsValue);
                }
                document.cookie =
                  'userRole=' +
                  userRole +
                  ';domain=.' +
                  environment.cookiesDomain +
                  ';path=/';
                this.toPageTredirection(res.data.properties.user_type, '');
              }
            } else if (res.user_type == 'Group') {
              this.toastr.error(res.message);
              this.authService.loggedOutCookieClear();
              setTimeout(() => {
                if (window.location.hostname == 'booking.classcover.com.au') {
                  window.location.replace('https://app.classcover.com.au/');
                } else if (
                  window.location.hostname == 'booking-test.classcover.com.au'
                ) {
                  window.location.replace('https://phoenix.classcover.com.au/');
                } else if (
                  window.location.hostname == 'qld-beta.classcover.com.au'
                ) {
                  window.location.replace('https://gamma.classcover.com.au/');
                } else {
                  window.location.replace('https://phoenix.classcover.com.au/');
                }
                this.ngxService.stop();
              }, 2000);
            } else if (res.user_type == 'Teacher') {
              this.toastr.error(res.message);
              this.authService.loggedOutCookieClear();
              setTimeout(() => {
                if (window.location.hostname == 'booking.classcover.com.au') {
                  window.location.replace('https://app.classcover.com.au/');
                } else if (
                  window.location.hostname == 'booking-test.classcover.com.au'
                ) {
                  window.location.replace('https://phoenix.classcover.com.au/');
                } else if (
                  window.location.hostname == 'qld-beta.classcover.com.au'
                ) {
                  window.location.replace('https://gamma.classcover.com.au/');
                } else {
                  window.location.replace('https://phoenix.classcover.com.au/');
                }
                this.ngxService.stop();
              }, 2000);
            } else {
              this.toastr.error(res.message);
              this.authService.loggedOutCookieClear();
              setTimeout(() => {
                if (window.location.hostname == 'booking.classcover.com.au') {
                  window.location.replace('https://app.classcover.com.au/');
                } else if (
                  window.location.hostname == 'booking-test.classcover.com.au'
                ) {
                  window.location.replace('https://phoenix.classcover.com.au/');
                } else if (
                  window.location.hostname == 'qld-beta.classcover.com.au'
                ) {
                  window.location.replace('https://gamma.classcover.com.au/');
                } else {
                  window.location.replace('https://phoenix.classcover.com.au/');
                }
                this.ngxService.stop();
              }, 2000);
            }
          });
        },
        error: (err) => {
          this.ngxService.stop();
          this.sharedService.announcement.next(
            'An error occurred while fetching user data.'
          );
          this.mandatoryMessage = false;
          this.validationMessage = true;
          this.error_log = err.error.error_log;
          this.sharedService.announcement.next(err.error.error_log);
          this.ngxService.stop();
        },
      });
    }
    else if (type === 'email') {
      this.authService.loginEmailVerify(payload).subscribe({
        next: (res) => {
          if (!res.status) {
            this.otpError = res.message || 'Invalid code. Please check and try again.';
            this.ngxService.stop();
            return
          }
          // console.log('Login successful:', res);
          this.commonService.getUserData('').subscribe((res) => {
            if (res.status) {
              if (
                window.location.hostname == 'booking.classcover.com.au' &&
                res.data.properties.job_only_school == true
              ) {
                window.location.replace('https://jobs.classcover.com.au');
              }
              // ...existing code...
              var userRole = res.data.properties.user_type.replace(
                /[^a-zA-Z ]/g,
                ''
              );
              // ...existing code...
              if (
                userRole != 'Group' &&
                userRole != 'GroupCoordinator' &&
                userRole != 'Teacher' &&
                userRole != 'Tracer'
              ) {
                this.is_job_only_user = res.data.properties.job_only_school;
                localStorage.setItem(
                  'schoolId',
                  res.data.mixpanel_data.school_id
                );
                localStorage.setItem(
                  'current_plan',
                  res.data.mixpanel_data.current_plan
                );
                localStorage.setItem('userData', JSON.stringify(res.data));
                localStorage.setItem('userRole', userRole);
                document.cookie =
                  'userRole=' +
                  userRole +
                  ';domain=.' +
                  environment.cookiesDomain +
                  ';path=/';
                localStorage.setItem(
                  'schoolAdId',
                  res.data.properties.additional_user_id
                );
                localStorage.setItem(
                  'schoolLogo',
                  res.data.mixpanel_data.school_avatar
                );
                localStorage.setItem(
                  'bookingSchool',
                  res.data.properties.is_booking_school
                );
                localStorage.setItem(
                  'booking_school',
                  res.data.properties.booking_school
                );
                this.mixpanelService.init(
                  res.data.mixpanel_data.user_id.toString(),
                  res.data.mixpanel_data.mixpanel_app_id
                );
                this.redirectToPage =
                  res.data.properties.is_land_on_preconfirmed;
                this.terms_accepted = res.data.properties.terms_accepted;
                this.CusMixData = res.data.mixpanel_data;
                this.toPageTredirection(
                  res.data.properties.user_type,
                  res.data.properties.is_onboarding,
                  res.data.mixpanel_data.email,
                  res.data.mixpanel_data.name,
                  res.data.mixpanel_data.user_id,
                );
              } else {
                localStorage.setItem('userData', JSON.stringify(res.data));
                localStorage.setItem('userRole', userRole);
                this.is_job_only_user = res.data.properties.job_only_teacher;
                // Set bookings_on_off cookie based on using_cc_to_B
                if (typeof res.data.properties.using_cc_to_B !== 'undefined') {
                  const bookingsValue = res.data.properties.using_cc_to_B ? '1' : '0';
                  document.cookie = 'bookings_on_off=' + bookingsValue + '; path=/;';
                  localStorage.setItem('bookings_on_off', bookingsValue);
                }
                document.cookie =
                  'userRole=' +
                  userRole +
                  ';domain=.' +
                  environment.cookiesDomain +
                  ';path=/';
                this.toPageTredirection(res.data.properties.user_type, '');
              }
            } else if (res.user_type == 'Group') {
              this.toastr.error(res.message);
              this.authService.loggedOutCookieClear();
              setTimeout(() => {
                if (window.location.hostname == 'booking.classcover.com.au') {
                  window.location.replace('https://app.classcover.com.au/');
                } else if (
                  window.location.hostname == 'booking-test.classcover.com.au'
                ) {
                  window.location.replace('https://phoenix.classcover.com.au/');
                } else if (
                  window.location.hostname == 'qld-beta.classcover.com.au'
                ) {
                  window.location.replace('https://gamma.classcover.com.au/');
                } else {
                  window.location.replace('https://phoenix.classcover.com.au/');
                }
                this.ngxService.stop();
              }, 2000);
            } else if (res.user_type == 'Teacher') {
              this.toastr.error(res.message);
              this.authService.loggedOutCookieClear();
              setTimeout(() => {
                if (window.location.hostname == 'booking.classcover.com.au') {
                  window.location.replace('https://app.classcover.com.au/');
                } else if (
                  window.location.hostname == 'booking-test.classcover.com.au'
                ) {
                  window.location.replace('https://phoenix.classcover.com.au/');
                } else if (
                  window.location.hostname == 'qld-beta.classcover.com.au'
                ) {
                  window.location.replace('https://gamma.classcover.com.au/');
                } else {
                  window.location.replace('https://phoenix.classcover.com.au/');
                }
                this.ngxService.stop();
              }, 2000);
            } else {
              this.toastr.error(res.message);
              this.authService.loggedOutCookieClear();
              setTimeout(() => {
                if (window.location.hostname == 'booking.classcover.com.au') {
                  window.location.replace('https://app.classcover.com.au/');
                } else if (
                  window.location.hostname == 'booking-test.classcover.com.au'
                ) {
                  window.location.replace('https://phoenix.classcover.com.au/');
                } else if (
                  window.location.hostname == 'qld-beta.classcover.com.au'
                ) {
                  window.location.replace('https://gamma.classcover.com.au/');
                } else {
                  window.location.replace('https://phoenix.classcover.com.au/');
                }
                this.ngxService.stop();
              }, 2000);
            }
          });
        },
        error: (err) => {
          this.ngxService.stop();
          this.sharedService.announcement.next(
            'An error occurred while fetching user data.'
          );
          this.mandatoryMessage = false;
          this.validationMessage = true;
          this.error_log = err.error.error_log;
          this.sharedService.announcement.next(err.error.error_log);
          this.ngxService.stop();
        },
      });
    }
  }

  /**
   * Starts the OTP timer and manages resend state.
   */
  startOtpTimer(seconds: number) {
    this.otpTimer = seconds;
    this.canResendOtp = false;
    if (this.otpTimerInterval) {
      clearInterval(this.otpTimerInterval);
    }
    this.otpTimerInterval = setInterval(() => {
      this.otpTimer--;
      if (this.otpTimer <= 0) {
        // Only allow resend if under max limit
        if (this.otpSendCount < this.maxOtpSends) {
          this.canResendOtp = true;
        } else {
          this.canResendOtp = false;
        }
        clearInterval(this.otpTimerInterval);
      }
    }, 1000);
  }

  /**
   * Handles resending the OTP if allowed.
   */
  resendOtp() {
    if (!this.canResendOtp || this.otpSendCount >= this.maxOtpSends) return;
    this.otpSendCount++;
    if (this.otpSendCount >= this.maxOtpSends) {
      this.canResendOtp = false;
      return;
    }
    this.commonService.resendMFAOtp({ user_id: this.mfaUserId }).subscribe({
      next: (res: any) => {
        this.startOtpTimer(res.cooldown || 60);
        this.canResendOtp = false;
        this.toastr.success('OTP has been resent successfully.');
      },
      error: () => {
        // Optionally show error
      }
    });
  }
  sendSmsOtp() {
    this.ngxService.start();
    this.commonService.sendSmsMFAOtp({ user_id: this.mfaUserId }).subscribe({
      next: (res: any) => {
        if (res && res.status) {
          this.toastr.success(res.message || 'SMS OTP has been sent successfully.');
          this.isSmsOtpSent = true;
        } else {
          this.toastr.error(res?.message || 'Failed to send SMS OTP.');
        }
        this.ngxService.stop();
      },
      error: (err) => {
        this.toastr.error('Failed to send SMS OTP.');
        this.ngxService.stop();
      }
    });
  }


  ngOnDestroy(): void {
    if (this.otpTimerInterval) {
      clearInterval(this.otpTimerInterval);
    }
  }

  toPageTredirection(user: any, onboardingCheck: any, email?: any, name?: any, id?: any, avatarURL?: any) {
    this.from_page_cookie =
      document.cookie.match('(^|;)\\s*' + 'from' + '\\s*=\\s*([^;]+)')?.pop() ||
      '';
    this.route.queryParams.subscribe((params) => {
      this.postCallOut = params['type'];
    });
    if (this.is_job_only_user == false) {
      switch (user) {
        case 'School':
          if (this.terms_accepted == false && this.from_page_cookie != 'loginas') {
            window.location.replace('/school/terms-and-conditions');
            return;
          }
          // myExternalJs.SetIdCustomerIo(this.CusMixData);
          if (this.booking_school_switch_angular == true) {
            this.router.navigateByUrl('/school/jobs');
          } else {
            if (
              this.booking_id != undefined &&
              this.booking_id != null &&
              this.booking_id != ''
            ) {
              this.router.navigate([
                '/school/bookings-in-flight/' + this.booking_id,
              ]);
            } else if (onboardingCheck == true) {
              window.location.replace(
                environment.locationURL + 'school/school-onboarding'
              );
            } else if (this.redirectToPage == true) {
              this.router.navigateByUrl('/school/bookings/preconfirm-booking');
            } else {
              this.router.navigateByUrl('/school/bookings/booking-request');
            }
          }
          break;
        case 'Teacher':
          this.userData = JSON.parse(localStorage.getItem('userData') || '{}');
          if (this.profileBookings == 'profileBookings') {
            this.router.navigateByUrl('/teacher/profile');
          } else {
            if (this.jobSchoolUrl == true || !this.userData.properties.using_cc_to_B) {
              this.router.navigateByUrl('/teacher/jobs');
            } else {
              this.router.navigateByUrl('/teacher');
            }
          }
          break;
        case 'Group':
          this.router.navigateByUrl('/group');
          break;
        case 'GroupCoordinator':
          this.router.navigateByUrl('/co-ordinator');
          break;
        case 'Tracer':
          this.router.navigateByUrl('/tracer');
          break;
        default:
          this.router.navigateByUrl('/login');
          break;
      }
    } else {
      switch (user) {
        case 'School':
          if (this.postCallOut == 'postCallOut') {
            this.router.navigate(['/school/jobs/post-job'], {
              queryParams: { type: 'postCallOut' },
            });
          } else if (this.jobId != undefined) {
            this.router.navigate(['/school/jobs/job-details'], {
              queryParams: { job_id: this.jobId },
            });
          } else if (this.terms_accepted == true) {
            this.router.navigateByUrl('/school/jobs');
          } else if (this.terms_accepted == false && this.from_page_cookie != 'loginas') {
            this.router.navigateByUrl('/school/terms-and-conditions');
          }
          break;
        case 'Teacher':
          this.userData = JSON.parse(localStorage.getItem('userData') || '{}');
          if (this.profileBookings == 'profileBookings') {
            this.router.navigateByUrl('/teacher/profile');
          }
          else if (this.jobSchoolUrl == true || !this.userData.properties.using_cc_to_B) {
            this.router.navigateByUrl('/teacher/jobs');
          } else {
            this.router.navigateByUrl('/teacher');
          }
          break;
        case 'Group':
          this.router.navigateByUrl('/group');
          break;
        case 'GroupCoordinator':
          this.router.navigateByUrl('/co-ordinator');
          break;
        case 'Tracer':
          this.router.navigateByUrl('/tracer');
          break;
        default:
          this.router.navigateByUrl('/login');
          break;
      }
    }

    // Testing login as different roles
    // const userType = MOCK_USERS.find(u => u.role === user);

    // if (!userType) return;

    // // localStorage.setItem('token', userType.token);
    // localStorage.setItem('permissions', JSON.stringify(userType.permissions));
    // localStorage.setItem('role', userType.role);

    this.permissionService.loadPermissions();

  }

  showPassword = false;

  togglePassword() {
    this.showPassword = !this.showPassword;
  }
  resendEmailOtp() {
    if (this.otpSendCount >= this.maxOtpSends) return;
    this.otpSendCount++;
    if (this.otpSendCount >= this.maxOtpSends) {
      this.canResendOtp = false;
      return;
    }
    this.commonService.resendVerifyOtp({ user_id: this.mfaUserId }).subscribe({
      next: (res: any) => {
        this.startOtpTimer(60);
        this.canResendOtp = false;
        this.toastr.success('OTP has been resent successfully.');
      },
      error: () => {
        // Optionally show error
      }
    });
  }
}